<script lang="ts">
	export let options: { label: string; value: string }[] = [];
	export let selected: string[] = [];
	export let onChange = () => {};
	export let name = "";
</script>

<div class="checkbox-group">
	{#each options as option}
		<label class="checkbox-item">
			<input
				{name}
				type="checkbox"
				value={option.value}
				bind:group={selected}
				on:change={onChange}
			/>
			{option.label}
		</label>
	{/each}
</div>

<style>
	.checkbox-group {
		display: flex;
		flex-wrap: wrap;
		gap: 1.5rem;
	}

	.checkbox-item {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: 16px;
		color: #00071f;
	}

	.checkbox-item input[type="checkbox"] {
		margin-right: 6px;
		width: 16px;
		height: 16px;
		accent-color: #003bed;
	}
</style>
